import React from 'react';
import { Button } from 'antd';
import scenarioCreate from '../../forms/scenarioCreate';
import Form from '../Form';

const ScenarioCreateModal = ({ onSubmit, scenarios }) => (
  <>
    <Form
      scaffold={scenarioCreate()}
      onSubmit={(formData, actions) => onSubmit(formData, actions)}
      isSubmitting
      lookupData={{ scenarios }}
      actions={({ submitForm, isSubmitting }) => (
        <>
          <Button
            type="primary"
            onClick={submitForm}
            disabled={isSubmitting}
          >
            Create
          </Button>
        </>
      )}
    />
  </>
);


export default ScenarioCreateModal;
